// extracted by mini-css-extract-plugin
export default {"root":"NotificationPanel_root","backdrop":"NotificationPanel_backdrop","container":"NotificationPanel_container","snackbar":"NotificationPanel_snackbar"};